module.exports = __webpack_public_path__ + "img/tour-2.aa1fc151.svg";